import React from 'react'
import PropTypes from 'prop-types'

import styles from './styles.module.css'

const Switch = ({ checked, defaultChecked, ...props }) => {
  return (
    <label className={styles.switch}>
      <input
        type="checkbox"
        checked={checked}
        defaultChecked={defaultChecked}
        {...props}
      />
      <span className={styles.slider}></span>
    </label>
  )
}

Switch.propTypes = {
  checked: PropTypes.bool,
  defaultChecked: PropTypes.bool,
}

export default Switch
